<template>
  <v-container>
    <v-row>
      <v-col cols="12">
        <v-data-table
          :headers="headers"
          :items-per-page="itemsPerPage"
          :items="estimates"
          item-key="id"
          show-expand
          :single-expand="true"
          :footer-props="{
            'items-per-page-options': rowsPerPageItems,
          }"
        >
          <template v-slot:[`item.edit`]="{ item }">
            <div>
              <v-btn outlined @click="onEdit(item.id)">
                <v-icon left>mdi-pencil</v-icon>Edit
              </v-btn>
            </div>
          </template>
          <template v-slot:[`item.delete`]="{ item }">
            <div>
              <v-btn :disabled="deleteDisabled" outlined @click="onDelete(item.id)">
                <v-icon left>mdi-delete</v-icon>Delete
              </v-btn>
            </div>
          </template>
          <template v-slot:expanded-item="{ headers, item }">
            <td :colspan="headers.length">
              <div class="expand-row">
                <v-row>
                  <v-col cols="12" xl="2" lg="2" md="2" sm="12">
                    <v-row>
                      <strong>Address:</strong>
                    </v-row>
                    <v-row>
                      {{ item.address }}
                    </v-row>
                    <v-row>{{ item.city }} </v-row>
                    <v-row>{{ item.zipcode }} </v-row>
                  </v-col>
                  <v-col cols="12" xl="2" lg="2" md="2" sm="12">
                    <v-row>
                      <strong> Project Type:</strong>
                    </v-row>
                    <v-row v-if="item.projectType.length > 0">
                      {{ item.projectType }}
                    </v-row>
                    <v-row v-if="item.projectType.length == 0">
                      (No project type given)
                    </v-row>
                  </v-col>
                  <v-col cols="12" xl="8" lg="8" md="8" sm="12">
                    <v-row>
                      <strong> Message:</strong>
                    </v-row>
                    <v-row v-if="item.message.length > 0">
                      {{ item.message }}
                    </v-row>
                    <v-row v-if="item.message.length == 0">
                      (No message was given)
                    </v-row>
                  </v-col>
                </v-row>
              </div>
            </td>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
    <div>
    </div>
    <div>
      <v-snackbar v-model="snackbar" :timeout="-1" centered>
        Delete the selected Estimate
        <template v-slot:action="{ attrs }">
          <v-btn text v-bind="attrs" @click="onYes" class="button"> Yes </v-btn>
          <v-btn text v-bind="attrs" @click="onNo" class="button"> No </v-btn>
        </template>
      </v-snackbar>
    </div>
        <v-btn outlined text @click="onAlert">
        Alert
      </v-btn>
  </v-container>
</template>

<script>
import EstimateService from "@/_services/api/estimate-service";
import notificationMixin from "@/mixins/notification-mixin";
import router from "@/router";
import store from "@/store"

export default {
  name: "estimate-list",

  components: {
  },

  mixins: [notificationMixin],
  created() {
    console.log("created()");
    this.fetch();
  },

  data: () => ({
    deleteDisabled: true,
    estimates: [],
    headers: [
      {
        text: "",
        align: "center",
        groupable: false,
        sortable: false,
        value: "edit",
        width: 60,
      },
      {
        text: "",
        align: "center",
        groupable: false,
        sortable: false,
        value: "delete",
        width: 60,
      },
      {
        text: "Name",
        align: "start",
        groupable: false,
        sortable: true,
        value: "name",
      },
      {
        text: "email",
        align: "start",
        groupable: false,
        sortable: true,
        value: "email",
      },
      {
        text: "Phone",
        align: "start",
        groupable: false,
        sortable: true,
        value: "phone",
      },
      {
        text: "Date",
        align: "start",
        groupable: false,
        sortable: true,
        value: "estimateDate",
      },
    ],
    deleteId: -1,
    itemsPerPage: 10,
    rowsPerPageItems: [10, 25, 50, 100],
    snackbar: false,
  }),

  mounted() {
    console.log("mounted");
    this.deleteDisabled = !store.getters.isAdministrator;
    console.log(this.deleteDisabled);
  },
  
  methods: {
    fetch() {
      EstimateService.list().then((result) => {
        this.estimates = result
      });
    },

    onDelete(id) {
      console.log("onDelete() ", id)
      this.deleteId = id
      this.snackbar = true
    },

    onEdit(id) {
      console.log("onEdit() ", id)
      router.push("estimate/" + id)
    },

    onNo() {
      this.snackbar = false
    },

    onYes() {
      this.snackbar = false
      if (this.deleteId != -1) {
        EstimateService.delete(this.deleteId).then((result) => {
          if(result.status){
            const notification = {
              title: "Estimate",
              status: "success",
              messages: ["The estimate was deleted"],
            };
            store.commit("setNotification", notification);
          } else {
            const notification = {
              title: "Estimate",
              status: "error",
              messages: ["The estimate was not deleted"],
            };
            store.commit("setNotification", notification);
          }
          this.fetch()
        });
      }
    },

    onAlert() {
      const notification = {
        title: "Estimate",
        status: "success",
        messages: ["The estimate was deleted"],
      };
      store.commit("setNotification", notification);
    },

    onStatusAlertClosed() {},
  },

  router,
};
</script>

<style lang="scss" scoped>
.button {
  margin-left: 20px;
}
.expand-row {
  padding: 1em;
}
</style>
